export const APP_CONFIG = {
  name: "iDetect365",
  version: "1.0.0",
  description: "Control Room",
} as const;

export const ROUTES = {
  // Auth
  LOGIN: "/login",
  RESET_PASSWORD: "/reset-password",

  // Dashboard
  DASHBOARD: "/dashboard",

  // Geospatial
  GEOSPATIAL: "/geospatial",
  GEOSPATIAL_AREA: "/geospatial/area/:areaId",
  GEOSPATIAL_NODE: "/geospatial/node/:nodeId",

  // Risk & Alerts
  RISKS: "/risks",
  RISK_DETAIL: "/risks/:riskId",

  // Sightings & Detections
  SIGHTINGS: "/sightings",
  SIGHTING_DETAIL: "/sightings/:sightingId",

  // Work Orders / Jobs
  WORK_ORDERS: "/work-orders",
  WORK_ORDER_DETAIL: "/work-orders/:workOrderId",
  DISPATCH: "/dispatch",

  // Nodes
  NODES: "/nodes",
  NODE_DETAIL: "/nodes/:nodeId",

  // Reports
  REPORTS: "/reports",
  REPORTS_OPERATIONAL: "/reports/operational",
  REPORTS_COMPLIANCE: "/reports/compliance",

  // AI Assistant
  AI_ASSISTANT: "/ai-assistant",

  // Settings & Admin
  SETTINGS: "/settings",
  USERS: "/users",

  // Error
  NOT_FOUND: "/not-found",
} as const;

export const API_ENDPOINTS = {
  BASE_URL: import.meta.env.VITE_API_URL || "http://localhost:8080",
  USERS: "/users",
  AUTH: "/auth",
} as const;
